import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
import moment from 'moment';

import { Link, Redirect} from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal, Popover } from 'react-bootstrap';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import FlightReportEditTab from './Elements/FlightReportEditTab';
import FlightReportLegsTab from './Elements/FlightReportLegsTab';
import FlightReportStaffsTab from './Elements/FlightReportStaffsTab';
import FlightReportRefuelTab from './Elements/FlightReportRefuelTab';
import FlightReportLogsTab from './Elements/FlightReportLogsTab';
import FlightReportWarningsTab from './Elements/FlightReportWarningsTab';
import FlightReportLegDelaysTab from './Elements/FlightReportLegDelaysTab';
import FlightReportApprovalsTab from './Elements/FlightReportApprovalsTab';
import LogbookAppIntegrations from '../LogbookAppIntegration/LogbookAppIntegrations';
import FlightReportOcurrencesTab from './Elements/FlightReportOcurrencesTab';
import FlightReportPowerCheckTab from './Elements/FlightReportPowerCheckTab';
import getLocale from '../../i18n/getLocale';

class FlightReportsEdit extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      logbook_app: '',
      modal_alerts: false,
      staff_alerts: {},
      global_alerts: {},
      flight_type: {},
      flight_report: {},
      flight_report_legs: {},
      flight_report_leg_delays: {},
      flight_report_occurrences: {},
      flight_report_legs_totals: {},
      flight_report_approvals: {},
      flight_report_reopen_warnings: {},
      aircraft_model_version_custom_items: {},
      flight_report_power_checks: {},
      flight_report_staffs: {},
      flight_report_refuels: {},
      flight_report_fees: {},
      flight_report_logs: {},
      flight_report_warnings: {},
      daily_flights: [],
      airspace_responsibles_select: [],
      airport_operators_select: [],
      bases_select: [],
      aircrafts_select: [],
      flight_types_select: [],
      contracts_select: [],
      clients_select: [],
      locations_select: [],
      staffs_select: [],
      staff_mechanics_select: [],
      flight_report_legs_select: [],
      fuel_suppliers_select: [],
      companies_select: [],
      fuel_types_select: [],
      abnormal_occurrence_types_select: [],
      flight_ptbr_selects: [],
      flight_omni_selects: [],
      codes_ptbr_select: [],
      duties_select: [],
      errors_messages: [],
      flight_report_skytrac_ids: [],
      errors_listing: false,
      errors_save: false,
      errors_skytrac: false,
      error_skytrac: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.exportXml = this.exportXml.bind(this);
    this.export = this.export.bind(this);
    this.warnings = this.warnings.bind(this);
    this.active = this.active.bind(this);
    this.archive = this.archive.bind(this);
    this.activeAll = this.activeAll.bind(this);
    this.archiveAll = this.archiveAll.bind(this);
    this.saveAllUpdate = this.saveAllUpdate.bind(this);
    this.handleOffline = this.handleOffline.bind(this);

    this.locale = getLocale();
  }
  popover (title, boldText) {
    const regularTexts = Array.from(arguments).slice(1);
    return (
      <Popover id="popover-positioned-top" title={title}>
        {boldText != null && <strong>{boldText}</strong>}
        {boldText != null && <br/>}
        {regularTexts.map((text, i) => (
          <span key={i}>
            {i > 1 && <br/>}
            {text}
          </span>
        ))}
      </Popover>
    );
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.handleOffline()
    }
  }

  handleOffline (responseJson) {
    if(navigator.onLine) {
      this.setState({loaded: 2}, this.loadData(responseJson));
    } else {
      var flight_reports_by_id = {};
      if (localStorage.getItem("flight_reports_by_id")){
        flight_reports_by_id = localStorage.getItem("flight_reports_by_id");
        flight_reports_by_id = JSON.parse(flight_reports_by_id);
        if(typeof flight_reports_by_id[this.props.match.params.id] !== 'undefined') {
          this.setState({
            flight_report: flight_reports_by_id[this.props.match.params.id]['flight_report'],
            fuel_type: flight_reports_by_id[this.props.match.params.id]['fuel_type'],
            fuel_type_id: flight_reports_by_id[this.props.match.params.id]['fuel_type_id'],
            fuel_unity: flight_reports_by_id[this.props.match.params.id]['fuel_unity'],
            status_options: flight_reports_by_id[this.props.match.params.id]['status_options'],
            flight_report_legs: flight_reports_by_id[this.props.match.params.id]['flight_report_legs'],
            flight_report_leg_delays: flight_reports_by_id[this.props.match.params.id]['flight_report_leg_delays'],
            flight_report_legs_totals: flight_reports_by_id[this.props.match.params.id]['flight_report_legs_totals'],
            flight_report_occurrences: flight_reports_by_id[this.props.match.params.id]['flight_report_occurrences'],
            flight_report_staffs: flight_reports_by_id[this.props.match.params.id]['flight_report_staffs'],
            flight_report_refuels: flight_reports_by_id[this.props.match.params.id]['flight_report_refuels'],
            flight_report_fees: flight_reports_by_id[this.props.match.params.id]['flight_report_fees'],
            flight_report_logs: flight_reports_by_id[this.props.match.params.id]['flight_report_logs'],
            flight_report_warnings: flight_reports_by_id[this.props.match.params.id]['flight_report_warnings'],
            flight_report_reopen_warnings: flight_reports_by_id[this.props.match.params.id]['flight_report_reopen_warnings'],
            flight_report_approvals: flight_reports_by_id[this.props.match.params.id]['flight_report_approvals'],
            bases_select: flight_reports_by_id[this.props.match.params.id]['bases_select'],
            aircrafts_select: flight_reports_by_id[this.props.match.params.id]['aircrafts_select'],
            flight_types_select: flight_reports_by_id[this.props.match.params.id]['flight_types_select'],
            contracts_select: flight_reports_by_id[this.props.match.params.id]['contracts_select'],
            clients_select: flight_reports_by_id[this.props.match.params.id]['clients_select'],
            flight_type: flight_reports_by_id[this.props.match.params.id]['flight_type'],
            locations_select: flight_reports_by_id[this.props.match.params.id]['locations_select'],
            ptbr_codes_select: flight_reports_by_id[this.props.match.params.id]['ptbr_codes_select'],
            ptbr_operations_select: flight_reports_by_id[this.props.match.params.id]['ptbr_operations_select'],
            ptbr_external_loads_select: flight_reports_by_id[this.props.match.params.id]['ptbr_external_loads_select'],
            ptbr_fuels_select: flight_reports_by_id[this.props.match.params.id]['ptbr_fuels_select'],
            abnormal_occurrence_types_select: flight_reports_by_id[this.props.match.params.id]['abnormal_occurrence_types_select'],
            staffs_select: flight_reports_by_id[this.props.match.params.id]['staffs_select'],
            duties_select: flight_reports_by_id[this.props.match.params.id]['duties_select'],
            flight_report_legs_select: flight_reports_by_id[this.props.match.params.id]['flight_report_legs_select'],
            airspace_responsibles_select: flight_reports_by_id[this.props.match.params.id]['airspace_responsibles_select'],
            airport_operators_select: flight_reports_by_id[this.props.match.params.id]['airport_operators_select'],
            fuel_suppliers_select: flight_reports_by_id[this.props.match.params.id]['fuel_suppliers_select'],
            companies_select: flight_reports_by_id[this.props.match.params.id]['companies_select'],
            fuel_types_select: flight_reports_by_id[this.props.match.params.id]['fuel_types_select'],
            flight_ptbr_selects: flight_reports_by_id[this.props.match.params.id]['flight_ptbr_selects'],
            flight_omni_selects: flight_reports_by_id[this.props.match.params.id]['flight_omni_selects'],
            ptbr_departure_selects: flight_reports_by_id[this.props.match.params.id]['ptbr_departure_selects'],
            ptbr_flight_selects: flight_reports_by_id[this.props.match.params.id]['ptbr_flight_selects'],
            omni_departure_selects: flight_reports_by_id[this.props.match.params.id]['omni_departure_selects'],
            omni_flight_selects: flight_reports_by_id[this.props.match.params.id]['omni_flight_selects'],
            codes_ptbr_select: flight_reports_by_id[this.props.match.params.id]['codes_ptbr_select'],
            staff_mechanics_select: flight_reports_by_id[this.props.match.params.id]['staff_mechanics_select'],
          });
          this.handleAlert('', '', 'closed');
        } else {
          this.handleAlert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.mensagemOfflineSemVoo, 'error', 'open');
        }
      } else {
        this.handleAlert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.mensagemOfflineSemVoo, 'error', 'open');
      }
    }
  }
  updateData (responseJson) {
    // Alinha com o client: recarrega e exibe mensagens do responseJson
    this.setState({updated: 1}, this.loadData(responseJson));
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorio/voo/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/relatorios/voo');
        if (responseJson.status === 'success') {
          self.setState({
            logbook_app: responseJson.data.logbook_app,
            flight_report: responseJson.data.main,
            fuel_type: responseJson.data.fuel_type,
            fuel_type_id: responseJson.data.fuel_type_id,
            fuel_unity: responseJson.data.fuel_unity,
            status_options: responseJson.data.status_options,
            flight_report_legs: responseJson.data.flight_report_legs,
            flight_report_leg_delays: responseJson.data.flight_report_leg_delays,
            flight_report_legs_totals: responseJson.data.flight_report_legs_totals,
            flight_report_occurrences: responseJson.data.flight_report_occurrences,
            flight_report_staffs: responseJson.data.flight_report_staffs,
            aircraft_model_version_custom_items: responseJson.data.aircraft_model_version_custom_items,
            flight_report_power_checks: responseJson.data.flight_report_power_checks,
            flight_report_refuels: responseJson.data.flight_report_refuels,
            flight_report_fees: responseJson.data.flight_report_fees,
            flight_report_logs: responseJson.data.flight_report_logs,
            flight_report_warnings: responseJson.data.flight_report_warnings,
            flight_report_reopen_warnings: responseJson.data.flight_report_reopen_warnings,
            flight_report_approvals: responseJson.data.flight_report_approvals,
            daily_flights: responseJson.data.daily_flights,
            bases_select: responseJson.data.bases_select,
            aircrafts_select: responseJson.data.aircrafts_select,
            flight_types_select: responseJson.data.flight_types_select,
            contracts_select: responseJson.data.contracts_select,
            clients_select: responseJson.data.clients_select,
            flight_type: responseJson.data.flight_type,
            locations_select: responseJson.data.locations_select,
            ptbr_codes_select: responseJson.data.ptbr_codes_select,
            ptbr_operations_select: responseJson.data.ptbr_operations_select,
            ptbr_external_loads_select: responseJson.data.ptbr_external_loads_select,
            ptbr_fuels_select: responseJson.data.ptbr_fuels_select,
            abnormal_occurrence_types_select: responseJson.data.abnormal_occurrence_types_select,
            staffs_select: responseJson.data.staffs_select,
            duties_select: responseJson.data.duties_select,
            flight_report_legs_select: responseJson.data.flight_report_legs_select,
            airspace_responsibles_select: responseJson.data.airspace_responsibles_select,
            airport_operators_select: responseJson.data.airport_operators_select,
            fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
            companies_select: responseJson.data.companies_select,
            fuel_types_select: responseJson.data.fuel_types_select,
            flight_ptbr_selects: responseJson.data.flight_ptbr_selects,
            flight_omni_selects: responseJson.data.flight_omni_selects,
            ptbr_departure_selects: responseJson.data.ptbr_departure_selects,
            ptbr_flight_selects: responseJson.data.ptbr_flight_selects,
            omni_departure_selects: responseJson.data.omni_departure_selects,
            omni_flight_selects: responseJson.data.omni_flight_selects,
            codes_ptbr_select: responseJson.data.codes_ptbr_select,
            staff_mechanics_select: responseJson.data.staff_mechanics_select,
          });
          var flight_reports_by_id = {};
          if (localStorage.getItem("flight_reports_by_id")){
            flight_reports_by_id = localStorage.getItem("flight_reports_by_id");
            flight_reports_by_id = JSON.parse(flight_reports_by_id);
          }
          flight_reports_by_id[self.props.match.params.id] = self.state;
          
          var new_flight_reports_by_id = {};
          Object.keys(flight_reports_by_id).map(function(k) {
            var flight_report_line = flight_reports_by_id[k].flight_report;
            let flight_report_date = moment(flight_report_line.date, 'YYYY-MM-DD');
            let twoDaysAgo = moment().subtract(2, 'days');
            let difference = flight_report_date.isAfter(twoDaysAgo);

            if (difference) { // Se a data do relatório for menor que 2 dias
              new_flight_reports_by_id[k] = flight_reports_by_id[k];
            }
          })
          localStorage.setItem("flight_reports_by_id", JSON.stringify(new_flight_reports_by_id));

        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (self.state.updated == 1) {
          self.handleAlert(event.message, event.status, 'open');
          self.setState({updated: 0});
        } else {
          self.handleMessage();
        }
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger button-inline" value={cell} onClick={this.archive}><i className="fa fa-refresh"></i>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.botaoSubstituir}</button>
        <button className="btn btn-sm btn-success button-inline" value={cell} onClick={this.active}><i className="fa fa-toggle-right"></i>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.botaoIgnorar}</button>
      </div>
    );

    return botao;
  }

  // Fetch ativando um item
  active(event) {
    var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.ignorar);
    if (confirm) {
      var id = event.currentTarget.value;
      this.handleAlert('', '', 'open');
      var datasave = {
        ids: [id],
        flight_report_id: this.props.match.params.id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/manter', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ error_skytrac: false });
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  activeAll(event) {
    var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.ignorarTodos);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        ids: event,
        flight_report_id: this.props.match.params.id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/manter', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ error_skytrac: false });
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  
  // Fetch deletando um item
  archive(event) {
    var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.substituir);
    if (confirm) {
      var id = event.currentTarget.value;
      this.handleAlert('', '', 'open');
      var datasave = {
        ids: [id],
        flight_report_id: this.props.match.params.id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/skytrac', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ error_skytrac: false });
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando um item
  archiveAll(event) {
    var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.substituirTodos);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        ids: event,
        flight_report_id: this.props.match.params.id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/skytrac', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ error_skytrac: false });
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  saveAllUpdate(responseJson) {
    this.setState({
      errors_save: responseJson.errors_save,
      errors_save_messages: responseJson.data,      
    });
    this.updateData(responseJson);
  }

  changeStatus(url) {
    var confirm = this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.trocarStatusDoRelatorioDeVoo;
    if (window.confirm(confirm)) {
      var datasave = {origin: 'Manual', id: this.props.match.params.id};
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
          if(responseJson.status === 'warning') {
            self.setState({
              errors_listing: responseJson.data.errors_listing,
              errors_messages: responseJson.data.errors,
              errors_skytrac: responseJson.data.errors_skytrac,
              error_skytrac: responseJson.data.error_skytrac,
              flight_report_skytrac_ids: responseJson.data.flight_report_skytrac_ids,
            });
          } else {
            self.setState({
              errors_listing: false,
              errors_messages: [],
              error_skytrac: false,
              errors_skytrac: [],
            });
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  export(lang) {
    var self = this;
    var url = "/relatorio/voo/exportar/";
    if(lang === 'en') url = "/relatorio/voo/us/exportar/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        if(responseJson.status === 'warning') {
          self.setState({
            errors_listing: responseJson.data_view.errors_listing,
            errors_messages: responseJson.data_view.errors_messages,
          });
        } else {
          self.setState({
            errors_listing: false,
            errors_messages: [],
          });
        }
        self.handleAlert('', '', 'closed');
      });
    });
  }

  exportDB() {
    var self = this;
    var url = "/relatorio/voo/db/exportar/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.handleAlert('', '', 'closed');
        }
      });
    });
  }

  exportXml() {
    var self = this;
    var url = "/relatorio/voo/xml/exportar/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.handleAlert('', '', 'closed');
        }
      });
    });
  }

  warnings() {
    var self = this;
    var url = "/relatorio/voo/alertas/";
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_alerts: responseJson.data.staff, global_alerts: responseJson.data.global, modal_alerts: true});
          self.handleAlert('', '', 'closed');
        }
      });
    });
  }

  render() {
    var self = this;
    return (
<div>

  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.titulo} - {this.state.flight_report.report_number}</h3>
      <div className="grid-buttons pull-right">
        {
          (this.state.logbook_app == 1) &&
          <LogbookAppIntegrations
            ref={(ref) => { this.logbookAppIntegration = ref; }}
            flight_report_id={this.props.match.params.id}
            integrationType="cancel"
            updateData={this.updateData}
          />
        }
        <button onClick={() => this.warnings()} className="btn btn-warning"><i className="fa fa-fw fa-warning"></i><span className="hidden-xs hidden-sm">{this.locale.general.alertas}</span> </button>
        {
          (this.state.flight_report.status !== 0) ? 
          <Dropdown id="export-main">
            <Dropdown.Toggle bsStyle={'success'}>
            <i className="fa fa-fw fa-file-pdf-o"></i> <span className="hidden-xs hidden-sm">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoRelatorio}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="super-colors">
              <MenuItem onSelect={() => {this.export('pt')}}>Português</MenuItem>
              <MenuItem onSelect={() => {this.export('en')}}>English</MenuItem>
            </Dropdown.Menu>
          </Dropdown>
          : ''
        }
        {
          (this.state.flight_report.status === 5 || this.state.flight_report.status === 4 || this.state.flight_report.status === 3) ? <button onClick={() => this.exportDB()} className="btn btn-success"><i className="fa fa-fw fa-file-pdf-o"></i><span className="hidden-xs hidden-sm">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoExtratoDB}</span></button> : ''
        }
        {
          (this.state.flight_report.status === 5 || this.state.flight_report.status === 4 || this.state.flight_report.status === 3) ? <button onClick={() => this.exportXml()} className="btn btn-success"><i className="fa fa-fw fa-file-excel-o"></i><span className="hidden-xs hidden-sm">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoXML}</span></button> : ''

        }
        {(this.state.flight_report.status === 0 || this.state.flight_report.status === 1) ?
          <Dropdown id="revisions">
            <Dropdown.Toggle bsStyle={'primary'}>
              <i className="fa fa-fw fa-certificate"></i> {this.state.flight_report.status_str}
            </Dropdown.Toggle>
              {(this.state.flight_report.status === 0) ?
                <Dropdown.Menu className="super-colors">
                  <MenuItem onSelect={this.changeStatus} eventKey={'/relatorio/voo/status/rascunho'}>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoRelatorioDeVoo.TrocarParaRascunho}</MenuItem>
                </Dropdown.Menu>
              :
                <Dropdown.Menu className="super-colors">
                  <MenuItem onSelect={this.changeStatus} eventKey={'/relatorio/voo/status/finalizado'}>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoRelatorioDeVoo.TrocarParaFinalizado}</MenuItem>
                  <MenuItem onSelect={() => {
                    if (this.state.logbook_app == 1 && (this.state.flight_report.logbook_external_status == 0 || this.state.flight_report.logbook_external_status == null) && this.logbookAppIntegration) {
                      this.logbookAppIntegration.getLogbookLegs();
                    } else {
                      this.changeStatus('/relatorio/voo/status/cancelado');
                    }
                  }}>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoRelatorioDeVoo.TrocarParaCancelado}</MenuItem>
                </Dropdown.Menu>
              }
          </Dropdown>
          :
          <button  className="btn btn-primary" disabled><i className="fa fa-fw fa-certificate"></i>  {this.state.flight_report.status_str}</button>

        }
        <Link to="/relatorios/voo" className="btn btn-default"><i className="fa fa-chevron-left"></i><span className="hidden-xs hidden-sm"> {this.locale.general.voltar}</span></Link>
      </div>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.erros}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      {this.state.errors_save &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_save: false, errors_save_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.erros_salvar}:</strong>
          {Object.keys(self.state.errors_save_messages).map(function(k) {
            var message = self.state.errors_save_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      <hr/>
      <FlightReportEditTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_id={this.props.match.params.id} flight_report={this.state.flight_report} bases_select={this.state.bases_select} aircrafts_select={this.state.aircrafts_select} flight_types_select={this.state.flight_types_select} flight_type={this.state.flight_type} clients_select={this.state.clients_select} contracts_select={this.state.contracts_select} staff_mechanics_select={this.state.staff_mechanics_select} daily_flights={this.state.daily_flights} />
      <hr/>
      <FlightReportStaffsTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_id={this.props.match.params.id} flight_report_staffs={this.state.flight_report_staffs} staffs_select={this.state.staffs_select} flight_report={this.state.flight_report} duties_select={this.state.duties_select} />
      <hr/>
      <FlightReportLegsTab saveAllUpdate={this.saveAllUpdate} updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report={this.state.flight_report} flight_report_id={this.props.match.params.id} flight_report_legs={this.state.flight_report_legs} flight_report_legs_totals={this.state.flight_report_legs_totals} locations_select={this.state.locations_select} ptbr_codes_select={this.state.ptbr_codes_select} ptbr_operations_select={this.state.ptbr_operations_select} ptbr_external_loads_select={this.state.ptbr_external_loads_select} ptbr_fuels_select={this.state.ptbr_fuels_select} staffs_select={this.state.staffs_select} duties_select={this.state.duties_select} aircraft_model_version_custom_items={this.state.aircraft_model_version_custom_items} />
      <hr/>
      <FlightReportRefuelTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_id={this.props.match.params.id} fuel_type={this.state.fuel_type} fuel_type_id={this.state.fuel_type_id} fuel_types_select={this.state.fuel_types_select} fuel_unity={this.state.fuel_unity} fuel_suppliers_select={this.state.fuel_suppliers_select} companies_select={this.state.companies_select} staffs_select={this.state.staffs_select} flight_report_legs_select={this.state.flight_report_legs_select} ptbr_fuels_select={this.state.ptbr_fuels_select} flight_report_refuels={this.state.flight_report_refuels} />
      <hr/>
      {(this.state.flight_report && this.state.flight_report.power_checks == 1) &&
        <div>
          <FlightReportPowerCheckTab handleAlert={this.handleAlert} updateData={this.updateData} flight_report_id={this.props.match.params.id} flight_report_power_checks={this.state.flight_report_power_checks} />
          <hr/>
        </div>
      }
      {/* <FlightReportFeesTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_id={this.props.match.params.id} flight_report_legs_select={this.state.flight_report_legs_select} airspace_responsibles_select={this.state.airspace_responsibles_select} airport_operators_select={this.state.airport_operators_select} flight_report_fees={this.state.flight_report_fees} />
      <hr/> */}
      <FlightReportWarningsTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_warnings={this.state.flight_report_warnings} flight_report_id={this.props.match.params.id} flight_report={this.state.flight_report} />
      <hr/>
      <FlightReportApprovalsTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_id={this.props.match.params.id} flight_report_reopen_warnings={this.state.flight_report_reopen_warnings} flight_report_approvals={this.state.flight_report_approvals} flight_report={this.state.flight_report} logbook_app={this.state.logbook_app} popover={this.popover} />
      <hr/>
      <FlightReportLogsTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} flight_report_logs={this.state.flight_report_logs} />
    </div>
  </div>
  <Modal show={this.state.modal_alerts} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left"><strong>{this.locale.general.alertas}</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false})}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div>
        {
          Object.keys(self.state.global_alerts).map(function(k) {
            var alert = self.state.global_alerts[k];
            if(Array.isArray(alert)) {
              return(
                <div>
                  {Object.keys(alert).map(function(klert) {
                    var alert2 = alert[klert];
                    if(alert2) {
                      if (alert2.error && alert2.error === 1) {
                        return(
                          <div className={"box-alert box-alert-" + alert2.color}>
                            <div dangerouslySetInnerHTML={{__html: alert2.message}}></div>
                          </div>
                        );
                      }
                    }
                  })}
                </div>
              );
            }
          })
        }
      </div>
      <div>
        {
          Object.keys(self.state.global_alerts).map(function(k) {
            var alert = self.state.global_alerts[k];
            if(alert) {
              if (alert.error && alert.error === 1) {
                return(
                  <div className={"box-alert box-alert-" + alert.color}>
                    <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                  </div>
                );
              }
            }
          })
        }
      </div>
      <hr/>
      <div>
        {
          Object.keys(self.state.staff_alerts).map(function(nickname) {
            var alerts = self.state.staff_alerts[nickname];
            return(
              <div>
                <h4><strong>{nickname}</strong></h4>
                {Object.keys(alerts).map(function(k) {
                  var alert = alerts[k];
                  if(alert) {
                    if (alert.error === 1) {
                      return(
                        <div className={"box-alert box-alert-" + alert.color}>
                          <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
                        </div>
                      );
                    }
                  }
                })}
                <hr/>
              </div>
            );
          })
        }
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_alerts: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.error_skytrac} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left"><strong>{this.locale.general.alertas}</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({error_skytrac: false})}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <hr/>
      <h4>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.titulo}</h4>
      <hr/>
      <div className="btn-group">
        <button className="btn btn-danger button-inline" onClick={() => this.archiveAll(this.state.flight_report_skytrac_ids)}><i className="fa fa-refresh"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.botaoSubstituirTodos}</button>
        <button className="btn btn-success button-inline" onClick={() => this.activeAll(this.state.flight_report_skytrac_ids)}><i className="fa fa-toggle-right"></i> {this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.botaoIgnorarTodos}</button>
      </div>
      <hr/>
      <BootstrapTable data={this.state.errors_skytrac} pagination={true} striped={true} hover={true} options={{noDataText: this.locale.general.semDados}}>
        <TableHeaderColumn row={0} rowSpan={2} dataField={'id'} isKey={true} hidden={true} dataAlign="center" width='100'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn row={0} rowSpan={2} dataField={'leg_number'} dataAlign="center" width='100'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Trecho}</TableHeaderColumn>
        <TableHeaderColumn row={0} colSpan={4} dataAlign="center" width='100'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.FlightFollowing}</TableHeaderColumn>
        <TableHeaderColumn row={0} colSpan={4} dataAlign="center" width='100'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Preenchido}</TableHeaderColumn>
        <TableHeaderColumn row={1} dataField={'flight_following_engine_start_time_str'} dataAlign="center" width='160'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Partida}</TableHeaderColumn>
        <TableHeaderColumn row={1} dataField={'flight_following_takeoff_time_str'} dataAlign="center" width='160'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Decolagem}</TableHeaderColumn>
        <TableHeaderColumn row={1} dataField={'flight_following_landing_time_str'} dataAlign="center" width='160'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Pouso}</TableHeaderColumn>
        <TableHeaderColumn row={1} dataField={'flight_following_engine_shutoff_time_str'} dataAlign="center" width='160'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Corte}</TableHeaderColumn>
        <TableHeaderColumn row={1} dataField={'engine_start_time_str'} dataAlign="center" width='160'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Partida}</TableHeaderColumn>
        <TableHeaderColumn row={1} dataField={'takeoff_time_str'} dataAlign="center" width='160'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Decolagem}</TableHeaderColumn>
        <TableHeaderColumn row={1} dataField={'landing_time_str'} dataAlign="center" width='160'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Pouso}</TableHeaderColumn>
        <TableHeaderColumn row={1} dataField={'engine_shutoff_time_str'} dataAlign="center" width='160'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Corte}</TableHeaderColumn>
        <TableHeaderColumn row={0} rowSpan={2} dataField={"id"} dataAlign="center" dataFormat={this.ActionsButtons} width='220'>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Acoes}</TableHeaderColumn>
      </BootstrapTable>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({error_skytrac: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default FlightReportsEdit;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/FlightReportsEdit.js